import { SystemStyleObject } from '@chakra-ui/react';
import {
  ColorMode,
  getTypographyToken,
  pxToRem,
} from '@allergan-data-labs/alle-elements-core';
import { ButtonVariants } from '../';

export const getSplitButtonStyles = ({
  colorMode = 'light',
  variant = 'solid',
}: {
  colorMode?: ColorMode;
  variant?: ButtonVariants;
}): SystemStyleObject => ({
  ...getTypographyToken('Body/Medium/Medium'),
  gap: variant === 'solid' ? pxToRem('1px') : 0,
  '& > *:focus': {
    zIndex: 1,
  },
});

export const getSplitButtonActionMenuStyles = (
  variant: ButtonVariants
): SystemStyleObject => {
  return {
    marginInlineStart: variant === 'solid' ? 0 : pxToRem('-1px'),
    _active: {}, // to prevent the default active styles
  };
};
